export enum DataConfirmPath {
  token = "token"
}

export interface PathParams {
  [DataConfirmPath.token]: string;
}
